
<template>
  <div style="height: 100%">
    <div class="home-pc-body">
      <div class="body">
        <div class="about-us">
          <div class="about-text">
            <div class="about-header">{{config.about.title}}</div>
            <div class="about-header2">{{config.about.subTitle}}</div>
            <p class="content">{{config.about.brief}}<span class="about-more" @click="viewAboutMe()">{{getMoreText}} ▶</span></p>
          </div>
          <el-carousel class="about-img" height="324px">
            <el-carousel-item v-for="(item,index) in config.about.imagelist" :key="index">
              <img class="banner-img" :src="'static/pic/' + item" />
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="news-papers">
          <div class="list-inner">
            <div class="news-list">
              <div class="title">{{config.news.title}}</div>
              <div class="news" v-for="item in config.news.homelist" v-bind:key="item.id">
                <img class="news-img" :src="'static/pic/' + item.image" v-if="item.image" />
                <div class="news-content">
                  <div class="time">{{item.time}}</div>
                  <div class="news-title">{{item.title}}</div>
                  <div class="news-subtitle">{{item.subTitle}}</div>
                  <!-- <span class="news-more" @click="viewNews()">{{getMoreText}} ▶</span> -->
                </div>
              </div>
              <span class="news-more" @click="viewNews()">{{getMoreText}}</span>
            </div>
            <div class="paper-list">
              <div class="paper-title">{{config.publication.title}}</div>
              <div
                class="paper"
                v-for="item in config.publication.homelist"
                v-bind:key="item.id"
              >
                <div class="paper-list-title">
                  <span style="font-weight:700;">{{item.id}}. </span>{{item.title}}
                </div>
                <div class="paper-list-member" v-if="item.members">{{item.members}}</div>
                <div class="paper-list-info">
                  <span style="font-weight:700;">{{item.paper}} </span>{{item.others}}
                </div>
              </div>
              <span class="paper-more" @click="viewPublication()">{{getMoreText}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="home-mobile-body">
      <div class="body">
        <div class="about-us">
          <div class="about-text">
            <div class="about-header">{{config.about.title}}</div>
            <div class="about-header2">{{config.about.subTitle}}</div>
            <p class="content">{{config.about.content}}</p>
          </div>
          <el-carousel class="about-img" :height="bannerHeightInMobile">
            <el-carousel-item v-for="(item,index) in config.about.imagelist" :key="index">
              <img class="banner-img" :src="'static/pic/' + item" />
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="news-papers">
          <div class="list-inner">
            <div class="news-list">
              <div class="title">{{config.news.title}}</div>
              <div class="news" v-for="item in config.news.homelist" v-bind:key="item.id">
                <img class="news-img" :src="'static/pic/' + item.image" v-if="item.image" />
                <div class="news-content">
                  <div class="time">{{item.time}}</div>
                  <div class="news-title">{{item.title}}</div>
                </div>
              </div>
              <button class="news-more-btn" @click="viewNews()">{{getMoreText}}</button>
            </div>
            <div class="paper-list">
              <div class="paper-title">{{config.publication.title}}</div>
              <div
                class="paper"
                v-for="item in config.publication.homelist"
                v-bind:key="item.title"
              >
                <div class="paper-list-title">
                  <span style="font-weight:700;color:#1a5897;">{{item.id}}. </span>{{item.title}}
                </div>
                <div class="paper-list-member" v-if="item.members">{{item.members}}</div>
                <div class="paper-list-info">
                  <span style="font-weight:700;color:#1a5897;">{{item.paper}} </span>{{item.others}}
                </div>
              </div>
              <button class="paper-more-btn" @click="viewPublication()">{{getMoreText}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getCurLan, isChinese} from '@/util/tools'
import Axios from 'axios';
export default {
  name: "home-page",
  data() {
    return {
      bannerHeightInMobile: '100px',
      config: {
        about: {
          title: "关于我们",
          subTitle: "Surface is beautiful!",
          content:
            "欢迎来到中国科学院物理研究所表面物理国家重点实验室SF9组。\n低维量子材料中具有丰富的物性和量子效应。 对低维量子材料的研究， 需要在原子尺度上控制物质的结构、 在原子尺度上观察和分子物质的结构和物理性质的关系、 获得对物性的深刻理解。 我们课题组以分子束外延（ MBE） 手段探索新型低维量子材料的生长， 并利用低温扫描隧道显微镜（ STM）、 角分辨光电子能谱（ ARPES） 等原位分析手段， 开展其电子态调控及量子物性的研究。 ",
          imagelist: ["", ""]
        },
        publication: {
          title: "发表论文",
          homelist: [
            {
              id: "137. ",
              title:
                "Topological electronic structure in the antiferromagnet HoSbTe",
              members:
                "Shaosheng Yue, Yuting Qian, Meng Yang, Daiyu Geng, Changjiang Yi, Shiv Kumar, Kenya Shimada, Peng Cheng, Lan Chen, Zhijun Wang, Hongming Weng, Youguo Shi, Kehui Wu, Baojie Feng",
              paper: "Phys. Rev.",
              others: " B 102, 155109(2020)"
            }
          ]
        },
        news: {
          title: "新闻及进展",
          homelist: [
            {
              id: "137. ",
              title:
                "我们研究组的工作“硅烯的发现和物性研究”，荣获北京市科技奖一等奖",
              subTitle: "",
              content: "获奖团队：吴克辉、陈岚、冯宝杰、程鹏、孟胜。",
              image: "",
              time: "2012.12月"
            }
          ]
        }
      }
    };
  },
  mounted() {
    this.bannerHeightInMobile = (document.body.clientWidth - 40) * 3 / 5 + 'px'
    // this.config = getCurLan();
    var self = this
    getCurLan().then(res => {
      self.config = res
    })
  },
  computed: {
    getMoreText: function () {
      if (isChinese()) {
        return '查看更多'
      } else {
        return 'More'
      }
    }
  },
  methods: {
    viewNews () {
      this.$router.push({ name: 'news-page' })
    },
    viewPublication () {
      this.$router.push({ name: 'publication-page' })
    },
    viewAboutMe () {
      this.$router.push({ name: 'about-page' })
    }
  }
};
</script>
<style lang='scss' src='../assets/styles/pc/home-page.scss'></style>
<style lang='scss' src='../assets/styles/mobile/home-page.scss'></style>




// WEBPACK FOOTER //
// src/components/Home.vue